
<script>
import { watch, ref } from 'vue';
import pdfMake from "pdfmake/build/pdfmake";
import { pdfFileName, openPdf } from '@/utils/pdfFile';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import CompanyServices from '@/services/CompanyServices';
import moment from 'moment';
export default {
    props:{
        company_id: Number,
        count_number: Number,
        company_name: String,
    },
    setup(props){
        
        const pdfData=ref([]);

        const documentDefinition=ref({});
        const body=ref([]);
        const total_amount=ref(0);
        const total_boxes=ref(0);
        const total_cartons=ref(0);

        const loadPdf=async ()=>{
            await CompanyServices.getOneCompanyProductsPdf(props.company_id)
      			.then(response=>{
                    pdfData.value=response.data;

                    
      			})
                .then(() => {
                    let columns=[];
                    body.value=[];
                    columns=[
                        {text: 'No', style: 'defaultFont', alignment: 'center'},
                        {text: 'Name', style: 'defaultFont', alignment: 'center'},
                        {text: 'Per unit price', style: 'defaultFont', alignment: 'center'},
                        {text: 'Per Carton Price', style: 'defaultFont', alignment: 'center'},
                        {text: 'Cartons', style: 'defaultFont', alignment: 'center'},
                        {text: 'Boxes', style: 'defaultFont', alignment: 'center'},
                        {text: 'Total Amount', style: 'defaultFont', alignment: 'center'},
                        
                    ];
                    body.value.push(columns);
                    
                    let i=1;
                    total_amount.value=0;
                    total_boxes.value=0;
                    total_cartons.value=0;
                    pdfData.value.forEach(function(row) {
                                               
                        const dataRow=[];
                        const seriol_no={
                            text: i,
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center',
                            
                        };
                        dataRow.push(seriol_no);

                        const product_english_name={
                            style: ['defaultFont', 'mtEnglish'],
                            text: row['name']
                            
                        }
                        dataRow.push(product_english_name);
                        
                        
                        const cartons={
                            text: row['cartons'].toString(),
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        };
                        const initial_price_per_unit={
                            text: row['initial_price_per_unit'].toString(),
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        };
                        dataRow.push(initial_price_per_unit);


                        const Per_Carton_Price={
                            // Carton price = round(box price x boxes per carton) so it
                            // lands on a clean whole-rupee amount instead of drifting
                            // (e.g. 127.56 x 18 = 2296.08 -> 2296).
                            text: Math.round(row['boxes_per_carton'] * row['initial_price_per_unit']),
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center', 
                        }
                        dataRow.push(Per_Carton_Price);


                        dataRow.push(cartons);
                        
                        const boxes={
                            text: row['boxes'].toString(),
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        };
                        
                        dataRow.push(boxes);

                        const total={
                            text: Math.round(row['total_amount']).toString(),
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center',

                        }
                        dataRow.push(total);
                        total_amount.value =eval(total_amount.value)+Math.round(eval(row['total_amount']));
                        total_boxes.value =eval(total_boxes.value)+eval(row['boxes']);
                        total_cartons.value=eval(total_cartons.value)+eval(row['cartons']);
                        body.value.push(dataRow);
                        i++;
                    });
                   
                })
                .then(() => {
                    pdfMake.fonts = {
					
					Roboto: {
						normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
						bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
						italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
						bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
					},
				}
                    documentDefinition.value = {
                        content: [
                            
                            {
                                columns: [
                                    {
                                    width: '50%',
                                    text: 'Company: '+props.company_name,
                                    style: [ 'defaultFont', 'mb10' ]

                                    },
                                    {
                                    width: '50%',
                                    text: 'DATE: '+moment().format('DD/MM/YY'),
                                    style: [ 'defaultFont', 'textRight', 'mb10' ]
                                    },
                                ],
                                
                            },
                            {
                                
                                table: {
                                    headerRows: 1,
                                    dontBreakRows: true, 
                                    widths: [30,'*',60,'*',60,60,'*'],
                                    body: body.value
                                }
                            },
                            {
                                columns: [
                                    {
                                    width: '58%',
                                    text: 'Total Amount: ',
                                    style: [ 'defaultFont', 'textCenter', 'mb15']
                                    },
                                    {
                                    width: '39%',
                                    text: total_amount.value.toFixed(),
                                    style: [ 'defaultFont', 'textCenter', 'mb15' ]
                                    },
                                ],
                            },
                            {
                                columns: [
                                    {
                                    width: '58%',
                                    text: 'Total Boxes:',
                                    style: [ 'defaultFont', 'textCenter', 'mb15']
                                    },
                                    {
                                    width: '39%',
                                    text: total_boxes.value.toFixed(),
                                    style: [ 'defaultFont', 'textCenter', 'mb15']
                                    },
                                ],
                            },
                            {
                                columns: [
                                    {
                                    width: '58%',
                                    text: 'Total Cartons:',
                                    style: [ 'defaultFont', 'textCenter', 'mb15']
                                    },
                                    {
                                    width: '39%',
                                    text: total_cartons.value,
                                    style: [ 'defaultFont', 'textCenter', 'mb15']
                                    },
                                ],
                            },
                        ],
                        styles: {
                            defaultFont: {
                            fontSize: 11,
                            bold: true
                            },
                            textLeft: {
                            alignment: 'left'
                            },
                            textRight: {
                            alignment: 'right'
                            },
                            textCenter: {
                            alignment: 'center'
                            },
                            mt2: {
                            margin:[0,2,0,0]
                            },
                            mb2: {
                            margin:[0,0,0,2]
                            },
                            mb10: {
                            margin:[0,0,0,10]
                            },
                            mb15: {
                           margin: [0, 3, 0, 5],
                            },
                            mCustom: {
                            margin:[20,2,0,0]
                            },
                            
                            mtEnglish: {
                                margin:[0,10,0,0]
                            },
                        }
                        };
                })
                .then(() => {
                    
                    pdfMake.vfs = pdfFonts;
                    openPdf(pdfMake, documentDefinition.value, pdfFileName(['Company-Products', props.company_name], ''));
                });

                
        }
        watch( ()=>props.count_number, (currentValue, oldValue) => {
			if(currentValue!=oldValue && currentValue!=""){
                loadPdf();
			}
        });
        
        return {
            pdfData,
            documentDefinition,
            body,
            total_boxes,
            total_cartons,
            total_amount
        }
    }
}
</script>
